import { useState } from 'react';
import Toast from 'react-native-toast-message';
import { useDispatch, useSelector } from 'react-redux';
import * as cartActions from '~store/cart/actions/cart';
import * as catalogReducers from '~store/catalog/reducers/catalog';
import { notifyMe } from '~store/product-detail/thunks';
import { useNavigation } from '@react-navigation/native';
import {
  imageCdn,
  storeAsyncData,
  currencyFormat,
  formatPrice,
} from '~global/helpers';
import { addWishlist } from '~store/product-detail/thunks';
import { unwrapResult } from '@reduxjs/toolkit';
import { isWeb, isNative } from '~global/screens';
import {
  GoogleTagManager,
  BranchWebSDK,
  Facebook,
  Branch,
  InternalTracking,
  InsiderTracking,
} from '~global/sociolla.dm.lib';
import ProductUtils from '~global/utils/product';
import { addToBagBabyRegistry } from '~store/baby-registry/thunks';
import StringUtils from '~global/utils/string';
import RegistryUtils from '~global/utils/registry';

const ProductController = (props) => {
  const { $forEach, $size } = global;
  const {
    productData,
    navigator,
    productContainerStyle,
    productImageStyle,
    verticalMode,
    isSpecialPrice,
    isProductDetail,
    isPackContent, // Boolean value true and false this value using in product detail -> PackContent component
    maxWidth = 0,
    isInSlider = false,
    isNoPaddingHorizontal = false,
    customWidth = 0,
    useCenter = false,
    babyRegistry,
    isFriendsView,
    dataFlashSaleSelected = {},
    isShowRating,
    isHomeBannerProduct,
    momsChecklist,
  } = props;
  const { $get } = global;
  const dispatch = useDispatch();

  const isProductBabyRegistry = $size(babyRegistry);
  const UtilsRegistry = new RegistryUtils(babyRegistry);
  const UtilsProduct = new ProductUtils(productData || {});
  const stockDefaultCombination = productData?.default_combinatio?.stock;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigation = navigator ? navigator : useNavigation();
  const [showAddToBag, setShowAddToBag] = useState(false);
  const [quantity, setQuantity] = useState(
    productData?.qty ? productData?.qty : 1,
  );
  const isFlashSaleProduct = $size(dataFlashSaleSelected) ? true : false;
  const isFlashSaleEnded = dataFlashSaleSelected.is_ended;
  const isFlashSaleStarting = dataFlashSaleSelected.is_live ? true : false;
  const isUpComingFlashSale =
    dataFlashSaleSelected.is_coming_soon ||
    (!isFlashSaleStarting && !isFlashSaleEnded);
  const [statusFlashSale, setStatusFlashSale] = useState(null);
  const isEditProfile = useSelector(
    (state) => state.babyRegistry.isEditProfile,
  );
  const userData = useSelector((state) => state.auth.user);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const wishlistSyncData = useSelector(
    (state) => state.catalog.wishlistSyncData,
  );
  const productParam = UtilsProduct.getProductUriSchemes(productData);
  const getImage = () => {
    if (isProductBabyRegistry) {
      const coverImageUrl = UtilsRegistry.getImage(productData.combination_id);
      return coverImageUrl;
    }
    const imageDefault =
      productData.images &&
      Array.isArray(productData.images) &&
      productData.images.length;
    const defaultImageCombination =
      productData.default_combination &&
      productData.default_combination.images &&
      Array.isArray(productData.default_combination.images) &&
      productData.default_combination.images.length;
    if (imageDefault || defaultImageCombination) {
      let imageCover;
      if (defaultImageCombination) {
        const imageCoverLilla = productData.default_combination.images.find(
          (res) => res.is_lilla_cover,
        );
        if (imageCoverLilla) {
          imageCover = imageCoverLilla.url;
        }
      }
      if (imageDefault) {
        const imageCoverLilla = productData.images.find(
          (res) => res.is_lilla_cover,
        );
        if (imageCoverLilla) {
          imageCover = imageCoverLilla.url;
        }
      }
      if (!imageCover && imageDefault) {
        imageCover = productData.images[0].url;
      }
      if (!imageCover && defaultImageCombination) {
        imageCover = productData.default_combination.images[0].url;
      }
      return imageCover;
    }
  };
  const coverImageUrl = getImage();
  const coverImage = coverImageUrl
    ? imageCdn({ config: isWeb ? 'w=448' : 'w=366', image: coverImageUrl })
    : null;
  const reviewStats = productData.review_stats
    ? productData.review_stats
    : null;
  const brandName = productData.brand ? productData.brand.name : '';
  const productImageSource = coverImage ? coverImage : null;
  const rating = reviewStats ? reviewStats.average_rating : 0;
  const count = reviewStats ? reviewStats.total_reviews : 0;
  const showRatingStar = UtilsProduct.isShowReviewsOrRatings();
  const isInStock = isPackContent
    ? !productData.is_out_of_stock_lilla
    : UtilsProduct.isInStock();
  const isExclusiveDealsProduct = UtilsProduct.isExclusiveDealsProduct();
  const isEgiftProduct = UtilsProduct.isEgiftProduct();
  const isBundleProduct = UtilsProduct.isBundleProduct();
  const isBuyOneGetOneProduct = UtilsProduct.isBuyOneGetOneProduct();
  const isExclusiveProduct = UtilsProduct.isExclusiveProduct();
  const isPreOrderProduct = UtilsProduct.isPreOrderProduct();
  const isNewProduct = UtilsProduct.isNewProduct();
  const opacity = isInStock ? 1 : 0.5;
  const checkCombinationAttribute =
    checkIfEachCombinationsHasOnlyOneAttribute();
  const combinations =
    $size(checkCombinationAttribute.data) > 1
      ? checkCombinationAttribute
      : getListCombinations();
  const hasCombinations = $size(combinations.data) > 0 ? true : false;
  const showDiscount = Boolean(
    isNewProduct || productData.is_sale || productData.discount_range,
  );
  const moreCombinationNumberInfo = isProductBabyRegistry
    ? 0
    : `${$size(productData.combinations) - $size(combinations)}`;
  const isShowButtonDeleteProductRegistry =
    !isFriendsView && isEditProfile && isProductBabyRegistry;
  const isMultipleCombinationOnSale = showDiscount
    ? /(?:rp.*?rp)/gi.test(productData.price_after_discount_range)
    : false;

  // product flash sale
  const quotaFlashSale = defineFlashSaleQuota();

  if (!statusFlashSale && isFlashSaleProduct) {
    setStatusFlashSale(checkStatusFlashSale());
  }
  const isFlashSaleAlmostEmpty =
    quotaFlashSale.total_quota - quotaFlashSale.sold_quota <= 5 ? true : false;
  const progressWidth = getFlashSaleProgressWidth();
  const isFlashSaleStillAvailable =
    quotaFlashSale.sold_quota === 0 && quotaFlashSale.total_quota > 0;
  const isTwoCombinationsDifferentType =
    combinations?.data?.length === 2 &&
    combinations.data[0]?.type &&
    combinations.data[1]?.type &&
    combinations.data[0].type !== combinations.data[1].type;
  let wishlisted = false;
  const wishlistSource = (() => {
    if (productData.default_combination) {
      if (wishlistSyncData[productData.default_combination['_id']]) {
        wishlisted =
          wishlistSyncData[productData.default_combination['_id']].is_wishlist;
      } else {
        wishlisted = productData.default_combination.is_wishlist;
      }
    }
    return isLoggedIn && wishlisted
      ? require('~assets/img/product/wishlist-icon-active-v2.png')
      : require('~assets/img/product/wishlist-icon-v2.png');
  })();

  const addToBagCheck = () => {
    if (isProductBabyRegistry) {
      return 'modal_single_cart';
    }

    if (
      ['sellable_products', 'bundle_virtual', 'bundle_physical'].indexOf(
        productData.classification,
      ) > -1 ||
      productData?.special_price_voucher_id
    ) {
      if (
        ['bundle_virtual', 'bundle_physical'].includes(
          productData.classification,
        )
      ) {
        const findPackCombination =
          productData.pack_detail &&
          productData.pack_detail.findIndex(
            (res) => res.combinations && res.combinations.length > 1,
          );
        return !isNaN(findPackCombination) && findPackCombination > -1
          ? 'modal_multi_cart'
          : 'modal_single_cart';
      } else {
        return productData.combinations && productData.combinations.length > 1
          ? 'modal_multi_cart'
          : 'modal_single_cart';
      }
    } else {
      return 'product_detail';
    }
  };

  const notifyMeHandlerSuccess = async () => {
    const defaultCombinationId = productData?.default_combination?._id;

    const payload = {
      combination_id: defaultCombinationId,
      email: userData?.email || '',
      product_id: productData.id,
      user: {
        email: '',
        id: '',
        name: '',
      },
    };
    if (userData !== null) {
      payload.user = {
        email: userData.email,
        id: userData._id,
        name: userData.name,
      };
      try {
        await dispatch(notifyMe(payload))
          .then(unwrapResult)
          .then(async (response) => {
            if (response.success) {
              dispatch({
                type: 'MODAL/SHOW',
                modalName: 'notifyMeSuccess',
                data: productData,
              });
            } else {
              Toast.show({
                text1: 'Silakan coba lagi dalam beberapa saat.',
                type: 'error',
              });
            }
          })
          .catch((rejectedValueOrSerializedError) => {
            console.log(
              'rejectedValueOrSerializedError => ',
              rejectedValueOrSerializedError,
            );
          });
      } catch (err) {
        console.log(err);
      }
    } else {
      storeAsyncData('@storage_notify', payload);
      login();
    }
  };

  const addToBagHandler = (e) => {
    e.preventDefault();

    if (!isInStock && !(!isFlashSaleStillAvailable && isFlashSaleProduct)) {
      notifyMeHandlerSuccess();
      return;
    }

    const combinationId =
      productData.default_combination && productData.default_combination._id
        ? productData?.default_combination?._id
        : productData.combinations &&
          Array.isArray(productData.combinations) &&
          productData.combinations.length
        ? productData.combinations[0]._id
        : null;

    const payload = {
      ...(isProductBabyRegistry && {
        baby_registry_id: babyRegistry._id,
        baby_registry_user_name: babyRegistry?.user?.name,
        baby_registry_user_email: babyRegistry?.user?.email,
      }),
      product: {
        id: productData.id,
        combination_id: isProductBabyRegistry
          ? productData.combination_id
          : combinationId,
        quantity: 1,
      },
      action: 'add',
    };
    if (productData?.is_special_price_applicable) {
      payload.product = {
        ...payload.product,
        special_price_voucher_id: productData?.special_price_voucher_id,
        is_special_price: productData?.is_special_price_applicable,
      };
    }
    //is_pre_order
    if (productData?.default_combination?.is_pre_order) {
      payload.is_pre_order = true;
    }

    // payload for bundle without need to choose combination
    const is_pack =
      productData.classification === 'bundle_virtual' &&
      productData.pack_detail &&
      productData.pack_detail.filter(
        (res) => res.combinations && res.combinations.length === 1,
      );
    if (is_pack && is_pack.length) {
      const packProductOos = productData.pack_detail.filter(
        (pr) => pr.is_out_of_stock_lilla,
      );
      if (packProductOos?.length) {
        dispatch({
          type: 'MODAL/SHOW',
          modalName: 'productOos',
          data: packProductOos,
        });
        return;
      }
      payload.product = {
        ...payload.product,
        is_pack: true,
        pack: productData.pack_detail.map((data) => {
          return {
            combination_id: data.combinations[0]._id,
            product_id: data.id,
            quantity: data.quantity,
          };
        }),
      };
    }

    dispatch({ type: 'MODAL/HIDE', modalName: 'productAdded', data: '' });
    if (addToBagCheck() === 'product_detail') {
      // if need to go to product detail first
      redirectToProductDetail();
    } else if (addToBagCheck() === 'modal_single_cart') {
      // if no / single combination / bundle without need to choose combination
      dispatch({ type: 'MODAL/SHOW', modalName: 'loading' });

      if (isLoggedIn) {
        if (isNative) {
          Facebook.addToCart(productData, payload.product.quantity);
          Branch.addToCart(productData, payload.product.quantity);
        }

        if (isWeb) {
          GoogleTagManager.addToCart(productData, payload.product.quantity);
          BranchWebSDK.addToCart(productData, payload.product.quantity);
        }

        InternalTracking.addToCart({
          ...productData,
          payload,
        });

        if (isNative) {
          InsiderTracking.insiderAddToCart({
            ...productData,
            payload,
          });
        }
      }

      // adding detail data for product added to cart when user wasn't logged in
      if (!isLoggedIn) {
        payload.product.detailData =
          UtilsProduct.getDetailDataNotLogin(productData);
      }

      dispatch(cartActions.addProductToCart(payload)).then((res) => {
        dispatch({ type: 'MODAL/HIDE', modalName: 'loading' });
        dispatch({ type: 'MODAL/HIDE', modalName: 'notifyMeSuccess' });
        if (!res.error) {
          let productRegistry = {};
          if (isProductBabyRegistry) {
            // if user add to bag product registry, modify data product.
            // because on product registry user has picked combination
            const coverImageUrl = UtilsRegistry.getImage(
              productData.combination_id,
            );
            const combinationPicked = UtilsRegistry.getProduct(
              productData.combination_id,
            );
            productRegistry = JSON.parse(JSON.stringify(productData)); // deep copy product data
            productRegistry.combinations = [combinationPicked];
            productRegistry.images = [
              {
                is_cover: true,
                url: coverImageUrl,
              },
            ];
          }
          const productAdded = isProductBabyRegistry
            ? productRegistry
            : productData;
          dispatch({
            type: 'shoppingBag/setIsReloadCart',
            data: true,
          });
          dispatch({
            type: 'MODAL/SHOW',
            modalName: 'productAdded',
            data: {
              productData: productAdded,
              navigation,
            },
          });

          if (isLoggedIn) {
            dispatch(cartActions.getCartProductCount());
          }
          dispatch({ type: 'cart/incrementCartProductCount' });
        }
      });
    } else {
      dispatch({ type: 'MODAL/HIDE', modalName: 'loading' });
      dispatch({ type: 'MODAL/HIDE', modalName: 'notifyMeSuccess' });
      // if has more than one combination / bundle need to choose combination
      // console.log('going to modal_multi_cart')
      dispatch({
        type: 'MODAL/SHOW',
        modalName: 'addToCart',
        data: {
          productData,
          navigation,
        },
      });
    }
  };

  const redirectToProductDetail = () => {
    if (isPackContent) {
      return dispatch({
        type: 'MODAL/SHOW',
        modalName: 'previewImage',
        data: productData,
      });
    }
    if (showAddToBag) {
      onShowAddToBag(false);
    }
    let methodName = isNative
      ? isProductDetail
        ? 'push'
        : 'navigate'
      : 'navigate';

    methodName = 'push';
    if (!navigation[methodName]) {
      methodName = 'navigate';
    }
    const setProduct = {
      name: productData.name,
      id: productData.id,
      currency: 'IDR',
      price: productData.default_combination
        ? productData.default_combination.price_after_discount
        : '',
      brand: productData.brand.name,
      category: productData.default_category?.name || '',
      variant:
        productData?.default_combination &&
        Object.keys(productData.default_combination).length
          ? UtilsProduct.getCombinationName(productData.default_combination)
          : '',
    };

    if (isWeb) {
      GoogleTagManager.viewContent(productData);
      window.dataLayer.push({
        event: 'View product',
        ecommerce: {
          viewProduct: {
            products: [setProduct],
          },
        },
      });
    }

    if (isNative && productData?.recomendationId) {
      InsiderTracking.insiderClickRecomendation(productData);
    }

    navigation[methodName]('ProductDetailScreen', {
      id: productData.id,
      name: productData.name,
      slug: productData.slug,
      ...UtilsProduct.getProductUriSchemes(productData),
    });

    dispatch({ type: 'MODAL/HIDE', modalName: 'productAdded', data: '' });
    dispatch({ type: 'MODAL/HIDE', modalName: 'notifyMeSuccess' });
  };

  const wishlistHandler = async () => {
    if (!isLoggedIn) {
      login();
      return;
    }
    const defautlCombinationId = productData.default_combination['_id'];

    const payload = {
      product_combination_id: defautlCombinationId,
      product_id: productData.id,
    };

    dispatch({
      type: 'productDetail/toggleWislisht',
      productCombinationId: defautlCombinationId,
    });
    try {
      dispatch(
        catalogReducers.SET_WISHLIST_SYNC_DATA({
          [productData.default_combination['_id']]: {
            is_wishlist: wishlistSyncData[defautlCombinationId]
              ? !wishlistSyncData[defautlCombinationId].is_wishlist
              : !productData.default_combination.is_wishlist,
          },
        }),
      );

      dispatch(addWishlist(payload))
        .then(unwrapResult)
        .then(async (response) => {
          if (response.data.is_wishlisted && response.success) {
            if (isWeb) {
              GoogleTagManager.addToWishlist(productData);
            }

            if (isNative) {
              Facebook.addToWishlist({ ...productData, wishlisted });
              Branch.addToWishlist({ ...productData, wishlisted });
              InsiderTracking.insiderAddtoWishlist({
                ...productData,
                wishlisted,
              });
            }
          }
          if (!response.success) {
            dispatch(
              catalogReducers.SET_WISHLIST_SYNC_DATA({
                [productData.default_combination['_id']]: {
                  is_wishlist:
                    !wishlistSyncData[defautlCombinationId].is_wishlist,
                },
              }),
            );
          }
        })
        .catch((err) => {
          console.log('err => ', err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const addToBagBabyRegistryHandler = (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      login();
      return;
    }

    const payload = {
      product_id: productData.id,
      combination_id: $get(productData, 'default_combination._id', ''),
      product_name: productData.name,
      brand: {
        id: $get(productData, 'brand.id', ''),
        name: $get(productData, 'brand.name', ''),
      },
      qty: 1,
      total_purchased: 0,
    };

    if (addToBagCheck() === 'modal_single_cart') {
      dispatch(addToBagBabyRegistry(payload)).then((response) => {
        if (response.payload.success) {
          dispatch({
            type: 'MODAL/SHOW',
            modalName: 'productAdded',
            data: {
              productData: productData,
              attributes: $get(
                productData,
                'default_combination.attributes',
                {},
              ),
              navigation,
              baby_registry_id: $get(
                response,
                'payload.data.baby_registry_id',
                '',
              ),
            },
          });
        }
      });
    } else {
      //modal_multi_cart
      dispatch({
        type: 'MODAL/SHOW',
        modalName: 'addToCart',
        data: {
          productData,
          navigation,
          isRegistryChooseCombinations: true,
        },
      });
    }
  };

  const login = () => {
    if (isNative) {
      navigation.navigate('LoginControlScreen', { title: 'Login' });
    } else {
      dispatch({
        type: 'MODAL/SHOW',
        modalName: 'login',
        data: { navigation },
      });
    }
  };

  const onShowAddToBag = (value) => {
    let updateValue;

    if (isProductBabyRegistry) {
      if (value && isFriendsView && isInStock) {
        updateValue = value;
      } else if (value && !isInStock) {
        updateValue = value;
      }
    } else {
      updateValue = value;
    }
    if (isWeb) {
      setShowAddToBag(updateValue);
    }
  };

  const deleteProductHandler = async () => {
    dispatch({
      type: 'MODAL/SHOW',
      modalName: 'removeProductBabyRegistry',
      data: productData,
    });
  };

  function getListCombinations() {
    const combinations = { data: [], isMoreCombinations: false };
    let productCombinations = productData.combinations;

    if (isProductBabyRegistry) {
      const combinationPicked = UtilsRegistry.getProduct(
        productData.combination_id,
      );
      productCombinations = [combinationPicked];
    }

    if ($size(productCombinations) && !isEgiftProduct) {
      let countAdded = 0;
      $forEach(productCombinations, (combination) => {
        const attributesLength = $size(combination.attributes);
        if (attributesLength > 0) {
          $forEach(combination.attributes, (attribute, attributeType) => {
            if (attributeType.toLowerCase() !== 'non_specify') {
              // size || variant max 2, shade max 3
              const maxShowingAttribute = ['size', 'variant'].includes(
                attributeType.toLowerCase(),
              )
                ? 2
                : 3;
              if (countAdded < maxShowingAttribute && attributesLength === 1) {
                combinations.data.push({
                  ...attribute,
                  name: StringUtils.ucWordsAttributeName(attribute.name),
                  type: attributeType.toLowerCase(),
                });
              }

              if (attributesLength > 1) {
                combinations.isMoreCombinations = true;
                combinations.data.push({
                  name: 'More options available',
                  type: 'variant', //  for conditional statment in ui
                });
                return false;
              }
            }
          });
          countAdded++;
        }

        if (attributesLength > 1) {
          return false;
        }
      });
      return combinations;
    }
    return combinations;
  }

  checkIfEachCombinationsHasOnlyOneAttribute();

  function checkIfEachCombinationsHasOnlyOneAttribute() {
    const combinations = { data: [], isMoreCombinations: false };
    let productCombinations = productData.combinations;

    if (isProductBabyRegistry) {
      const combinationPicked = UtilsRegistry.getProduct(
        productData.combination_id,
      );
      productCombinations = [combinationPicked];
    }

    if ($size(productCombinations) && !isEgiftProduct) {
      $forEach(productCombinations, (combination) => {
        const attributesLength = $size(combination.attributes);
        if (attributesLength > 0) {
          if (
            $size(productCombinations) === 1 &&
            $size(combination.attributes) === 2
          ) {
            $forEach(combination.attributes, (attribute, attributeType) => {
              if (attributeType.toLowerCase() !== 'non_specify') {
                combinations.data.push({
                  ...attribute,
                  name: StringUtils.ucWordsAttributeName(attribute.name),
                  type: attributeType.toLowerCase(),
                });
              }
            });
          }
        }
      });
      return combinations;
    }
    return combinations;
  }

  function addProductCountHandler(type) {
    if (stockDefaultCombination < quantity && type === 'plus') {
      return;
    }
    const qty = type === 'plus' ? quantity + 1 : quantity - 1;
    if (qty < 1) {
      type = 'delete';
      dispatch({
        type: 'MODAL/SHOW',
        modalName: 'removeProductBabyRegistry',
        data: productData,
      });
    } else {
      setQuantity(qty);
    }
    const payload = {
      product_id: productData?.id,
      product_name: productData?.name,
      combination_id: productData?.combination_id,
      brand: {
        id: productData?.brand?.id,
        name: productData?.brand?.name,
      },
      qty,
    };

    dispatch(addToBagBabyRegistry(payload));
    dispatch({
      type: 'babyRegistry/updateCountProduct',
      data: {
        combination_id: productData?.combination_id,
        qty,
      },
    });
  }

  function defineFlashSaleQuota() {
    let sold_quota = 0;
    let total_quota = 0;
    if (productData.selected_variant) {
      if (productData.default_combination.sold_quota) {
        sold_quota = productData.default_combination.sold_quota;
      }
      if (productData.default_combination.total_quota) {
        total_quota = productData.default_combination.total_quota;
      }
    } else {
      if (productData.sold_quota) {
        sold_quota = productData.sold_quota;
      }
      if (productData.total_quota) {
        total_quota = productData.total_quota;
      }
    }

    return {
      sold_quota: Number(sold_quota) > 0 ? Number(sold_quota) : 0,
      total_quota: Number(total_quota),
    };
  }

  function checkStatusFlashSale() {
    const sold_quota = quotaFlashSale.sold_quota;
    const total_quota = quotaFlashSale.total_quota;
    if (productData.selected_variant) {
      if (
        !productData.default_combination.stock ||
        productData.default_combination.is_out_of_stock_lulla
      ) {
        return 'oos';
      }
      if ((sold_quota && sold_quota >= total_quota) || isFlashSaleEnded) {
        return 'fss';
      }
      return 'available';
    } else {
      const inStock = productData.combinations.filter(
        (c) => c.stock > 0 && !c.is_out_of_stock_lulla,
      );
      const isStockCombination =
        productData.pack_detail && productData.pack_detail.length
          ? true
          : Boolean(inStock.length);
      if (
        !productData.is_in_stock_original ||
        productData.is_out_of_stock_lulla ||
        !isStockCombination
      ) {
        return 'oos';
      }
      if (
        (productData.is_in_stock_original && !productData.is_in_stock) ||
        isFlashSaleEnded
      ) {
        return 'fss';
      }
      if (
        (productData.is_in_stock_original && !productData.is_in_stock) ||
        sold_quota >= total_quota ||
        isFlashSaleEnded
      ) {
        return 'fss';
      }
      return 'available';
    }
  }

  function getFlashSaleProgressWidth() {
    let sold = Math.floor(
      ((quotaFlashSale.total_quota - quotaFlashSale.sold_quota) * 100) /
        quotaFlashSale.total_quota,
    );
    sold =
      sold > 100 || statusFlashSale === 'oos' || statusFlashSale === 'fss'
        ? 100
        : 100 - sold;
    const total = 100;

    if (sold > 0) {
      sold = total - sold;
    }

    return {
      sold,
      total,
    };
  }

  function getFormattedPriceDiscount() {
    if (isUpComingFlashSale && isFlashSaleProduct) {
      if (combinations?.data?.length === 1 || isTwoCombinationsDifferentType) {
        return (
          productData?.default_combination?.price_after_discount_format + ' '
        );
      } else {
        return productData?.price_after_discount_range + ' ';
      }
    }

    if (
      isFlashSaleProduct &&
      productData?.default_combination &&
      (combinations?.data?.length === 1 || isTwoCombinationsDifferentType)
    ) {
      return currencyFormat(
        productData?.default_combination?.price_after_discount,
      );
    } else {
      return formatPrice(productData?.price_after_discount_range);
    }
  }

  function toggleCheckedProduct() {
    //momsChecklist?.typeOrigin only have value momChecklistProducts
    if (momsChecklist?.typeOrigin === 'momChecklistProducts') {
      momsChecklist?.handleCheklist(
        `${momsChecklist?.parentChecklist}-${productData.id}`,
      );
    } else {
      // untuk handle product dari momschecklist screen
      momsChecklist?.handleCheklist({
        checklistItemId: momsChecklist?.parentChecklist,
        productId: productData.id,
        isChecked: productData?.is_checked ? 1 : 0,
        subIdx: productData.subIdx,
        idx: productData.idx,
        productIndex: productData.productIndex,
      });
    }
  }

  return {
    productData,
    verticalMode,
    isSpecialPrice,
    productContainerStyle,
    productImageStyle,
    maxWidth,
    isInSlider,
    isNoPaddingHorizontal,
    useCenter,
    customWidth,
    isPackContent,
    wishlistHandler,
    wishlistSource,
    redirectToProductDetail,
    onShowAddToBag,
    productParam,
    isEgiftProduct,
    showAddToBag,
    productImageSource,
    opacity,
    showDiscount,
    isExclusiveProduct,
    isBundleProduct,
    isBuyOneGetOneProduct,
    isInStock,
    isPreOrderProduct,
    isNewProduct,
    isExclusiveDealsProduct,
    brandName,
    rating,
    count,
    showRatingStar,
    addToBagHandler,
    addToBagBabyRegistryHandler,
    combinations,
    moreCombinationNumberInfo,
    isFriendsView,
    isProductBabyRegistry,
    quantity,
    isEditProfile,
    addProductCountHandler,
    stockDefaultCombination,
    deleteProductHandler,
    isShowButtonDeleteProductRegistry,
    isFlashSaleProduct,
    dataFlashSaleSelected,
    isFlashSaleStarting,
    isFlashSaleEnded,
    isUpComingFlashSale,
    isShowRating,
    progressWidth,
    isHomeBannerProduct,
    statusFlashSale,
    quotaFlashSale,
    isFlashSaleAlmostEmpty,
    isFlashSaleStillAvailable,
    momsChecklist,
    toggleCheckedProduct,
    hasCombinations,
    isMultipleCombinationOnSale,
    getFormattedPriceDiscount,
    isTwoCombinationsDifferentType,
  };
};

export default ProductController;
